import * as React from "react";

import DirectDistance from "./DirectDistance";
import GuestRating from "./GuestRating";
import { CONTENT_TYPE } from "components/flexComponents/Hotels/views/HotelsViews/HotelUtils";

import { HotelsFlexModuleResult, Hotel } from "typings/microserviceModels/hotels-flex-module";
import { ExtendedContextStore } from "typings/flexFramework/FlexDefinitions";

interface DistanceOrRatingProps {
  model: HotelsFlexModuleResult;
  hotel: Hotel;
  context: ExtendedContextStore;
  className?: string;
}

const DistanceOrRating = ({ model, hotel, className = "", context }: DistanceOrRatingProps) => {
  const { contentRecipe, showDistanceOrReviewRating } = model;

  if (!showDistanceOrReviewRating) {
    return null;
  }

  return contentRecipe === CONTENT_TYPE.REVIEW ? (
    <GuestRating hotel={hotel} className={className} />
  ) : (
    <DirectDistance hotel={hotel} className={className} context={context} />
  );
};

export default DistanceOrRating;
